export enum NOTIFICATION_SETTINGS {
  'THRESHOLD' = 'threshold',
  'EMAIL' = 'email',
  'USSD_PUSH' = 'ussdPush'
}

interface NotificationMethod {
  enabled: boolean;
  recipients: string[];
}

export interface LowBalanceNotificationResponseData {
  [NOTIFICATION_SETTINGS.THRESHOLD]: number;
  [NOTIFICATION_SETTINGS.EMAIL]: NotificationMethod;
  [NOTIFICATION_SETTINGS.USSD_PUSH]: NotificationMethod;
}
